var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWmAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#64C2C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_1701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.775 11.787C7.24904 15.2041 5.48242 19.3162 5.48242 24.126C5.48242 28.9357 7.26111 33.0276 10.8185 36.4118C14.3758 39.7961 18.5848 41.492 23.4503 41.492C28.3784 41.492 32.6188 39.7936 36.1786 36.4118C39.736 33.0276 41.5146 28.9357 41.5146 24.126C41.5146 19.3162 39.736 15.2041 36.1786 11.787",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4989 35.3226L35.006 22.6677H11.9941L23.4989 35.3226Z",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4988 35.3226L29.6698 22.6677H17.3301L23.4988 35.3226Z",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6961 16.8495H28.3014L29.6698 22.6677H17.3301L18.6961 16.8495Z",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 22.6677L15.8701 16.8495H18.6962",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0072 22.6677L31.1288 16.8495H28.3027",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.498 7.50549V12.3683",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5547 9.29999L18.1781 13.5764",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4398 9.29999L28.8164 13.5764",
    stroke: "white",
    strokeWidth: 0.965364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_1701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 35,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWmAccounts);
export default __webpack_public_path__ + "static/media/WMAccounts.075ea7db44d55e37603b376afb53553d.svg";
export { ForwardRef as ReactComponent };